<mat-card *ngIf="claims">
  <form [formGroup]="invitationForm" (ngSubmit)="inviteUsers()">
    <ng-container formGroupName="users">
      <ng-container *ngFor="let user of newUsers; let i = index" formGroupName="{{i}}">
        <mat-form-field color="accent">
          <input matInput type="text" formControlName="email" placeholder="E-Mail" required/>
        </mat-form-field>
        @
        <mat-form-field color="accent">
          <mat-label>Domain</mat-label>
          <mat-select required formControlName="domain">
            <mat-option *ngFor="let d of domains" [value]="d">
              {{d}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button *ngIf="i > 0" (click)="removeUser(i)" mat-flat-button color="danger">
          <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
        </button>

      </ng-container>
      <p [style]="{'margin-top': 0}">
        <button mat-stroked-button color="accent" type="button" (click)="addUser()" class="left">Weitere E-Mail_adresse</button>
      </p>
    </ng-container>
    <p>Produkte</p>

    <mat-error *ngIf="!productSelected">
      Bitte wählen Sie mindestens ein Produkt aus.
    </mat-error>

    <ng-container formGroupName="products">
      <ul>
        <li *ngFor="let c of claims">
          <mat-checkbox [formControlName]="c.name">
            {{c.desc}}
          </mat-checkbox>
        </li>
      </ul>
    </ng-container>

    <p class="flex-reverse">
      <button mat-flat-button color="accent" type="submit">Nutzer einladen</button>
    </p>
  </form>
</mat-card>

<mat-card>
  <h2>Zugänge verwalten</h2>

  <form [formGroup]="searchForm">
    <ng-container *ngIf="domains && claims">
      <mat-grid-list cols="6" rowHeight="99px">

        <mat-grid-tile colspan="2">
          <mat-form-field class="w-99" color="accent">
            <input matInput type="text" formControlName="input" placeholder="Suche"/>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field class="w-99" color="accent">
            <mat-label>Produkt</mat-label>
            <mat-select formControlName="claim">
              <mat-option value="">Alle</mat-option>
              <mat-option *ngFor="let c of claims" [value]="c.name">
                {{c.desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field class="w-99" color="accent">
            <mat-label>Domain</mat-label>
            <mat-select formControlName="domain">
              <mat-option value="">Alle</mat-option>
              <mat-option *ngFor="let d of domains" [value]="d">
                {{d}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

      </mat-grid-list>
    </ng-container>

  </form>

  <ng-container *ngIf="usersDataSource && (domainUsers && domainUsers.length); else noSubs">
    <table mat-table [dataSource]="usersDataSource" class="user-table">

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email</th>
        <td mat-cell *matCellDef="let u"><div class="email">{{u.external_customer_id}}</div><span class="claim">{{getClaimDesc(u.claim_name)}}</span></td>
      </ng-container>

      <ng-container matColumnDef="delete" class="edit">
        <th mat-header-cell *matHeaderCellDef> Löschen</th>
        <td mat-cell *matCellDef="let c2c; let i = index" (click)="deleteClaim2Customer(c2c.id, i)">
          <button mat-flat-button
                  matTooltip="Mitarbeiterzugang löschen"
                  matTooltipPosition="above"
                  color="danger">
            <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="edit" class="edit">
        <th mat-header-cell *matHeaderCellDef> Bearbeiten</th>
        <td mat-cell (click)="editUser(c2c)" *matCellDef="let c2c">
          <button
            mat-flat-button [style]="{display: 'block', padding: '10px', width: '40px'}"
            matTooltip="Bearbeiten"
            matTooltipPosition="above"
            color="danger">
            <fa-icon [icon]="['fas', 'pen']"></fa-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>
  <ng-template #noSubs>
    <p><strong>Keine gültigen Zugänge gefunden!</strong></p>
  </ng-template>

  <mat-paginator *ngIf="pager.length && pager.length > 5"
                 [length]="pager.length"
                 [pageSize]="pager.pageSize"
                 [pageIndex]="pager.pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="switchPage($event)">
  </mat-paginator>

</mat-card>
